import React from 'react'
import { Row, Col, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import i18next from 'i18next'
import { Range } from 'immutable'
import GridContainer from './GridContainer'

export default class UsageLog extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1
    }
  }

  render() {
    const { usageLog, isSuperAdminView } = this.props

    const summaries = isSuperAdminView ? usageLog.groupBy(s => s.organisation.id) : usageLog

    return (
      <GridContainer>
        <Row>
          <Col md={12}>
            <header>
              <h1>{i18next.t('usage_log')}</h1>
            </header>

            <Row>
              <Col xs={6} sm={5}>
                <FormGroup controlId="year">
                  <ControlLabel>{i18next.t('year')}</ControlLabel>
                  <FormControl
                    name="year"
                    componentClass="select"
                    defaultValue={this.state.year}
                    onChange={this.onChange.bind(this)}
                  >
                    {Range(2016, new Date().getFullYear() + 2).map(year => (
                      <option value={year} key={year}>
                        {year}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>

              <Col xs={6} sm={5}>
                <FormGroup controlId="month">
                  <ControlLabel>{i18next.t('month')}</ControlLabel>
                  <FormControl
                    name="month"
                    componentClass="select"
                    defaultValue={this.state.month}
                    onChange={this.onChange.bind(this)}
                  >
                    {Range(1, 13).map(month => (
                      <option value={month} key={month}>
                        {month}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>

              <Col sm={2}>
                <Button onClick={this.onSummarize.bind(this)} block style={{ marginTop: 26 }}>
                  {i18next.t('select')}
                </Button>
              </Col>
            </Row>

            <br />

            {isSuperAdminView &&
              summaries.count() > 0 && (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>{i18next.t('organisation')}</th>
                        <th />
                        <th style={{ textAlign: 'right' }}>
                          WOPI360
                          <small style={{ marginLeft: 5 }}>({i18next.t('pcs')})</small>
                        </th>
                        <th style={{ textAlign: 'right' }}>
                          WOPI
                          <small style={{ marginLeft: 5 }}>({i18next.t('pcs')})</small>
                        </th>
                        <th style={{ textAlign: 'right' }}>{i18next.t('unit_price_wopi')}</th>
                        <th style={{ minWidth: 100 }} />
                      </tr>
                    </thead>

                    <tbody>
                      {summaries.map((summary, organisationId) => {
                        const wopiSummary = summary
                          .filter(s => s.log.questionnaireType == 'wopi')
                          .first()
                        const wopi360Summary = summary
                          .filter(s => s.log.questionnaireType == 'wopi360')
                          .first()

                        return (
                          <tr key={organisationId}>
                            <td>{summary.first().organisation.name}</td>

                            <td style={{ maxWidth: 250 }}>
                              <small style={{ fontSize: 12 }}>
                                {summary.first().organisation.notes}
                              </small>
                            </td>

                            <td style={{ maxWidth: 100, textAlign: 'right' }}>
                              {wopi360Summary ? wopi360Summary.log.amount : 0}
                            </td>

                            <td style={{ maxWidth: 100, textAlign: 'right' }}>
                              {wopiSummary ? wopiSummary.log.amount : 0}
                            </td>

                            <td style={{ maxWidth: 100, textAlign: 'right' }}>
                              {summary.first().organisation.unitPriceWopi}&euro;
                            </td>

                            <td style={{ maxWidth: 30, textAlign: 'right' }}>
                              {wopiSummary ? wopiSummary.log.amount : 0} &times;{' '}
                              {summary.first().organisation.unitPriceWopi}&euro; ={' '}
                              <strong>
                                {(wopiSummary ? wopiSummary.log.amount : 0) *
                                  summary.first().organisation.unitPriceWopi}&euro;
                              </strong>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              )}

            {!isSuperAdminView &&
              summaries.count() > 0 && (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'right' }}>
                          WOPI
                          <small style={{ marginLeft: 5 }}>({i18next.t('pcs')})</small>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td style={{ textAlign: 'right' }}>
                          <strong>
                            {summaries.filter(s => s.questionnaireType == 'wopi').first().amount}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
          </Col>
        </Row>
      </GridContainer>
    )
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSummarize(e) {
    this.props.onSummarize(this.state.year, this.state.month)
  }
}



// WEBPACK FOOTER //
// ./src/components/UsageLog.js